module.exports = __webpack_public_path__ + "static/media/luna1.62141705.svg";